import {
    ALIGN,
    APP,
} from '_pixiSrc/globals';
import {
    DEFAULT_USER_DATA,
    ERROR,
    GAME_DATA_KEY,
    GAME_PROPERTY_KEY,
} from '../Constants';
import { getUserData, setWallet } from '../network/Session';

import AudioManager from '../ui/AudioManager';
import BigWin from '../ui/BigWin';
import Button from '../ui/Button';
import DynamicData from '../ui/DynamicData';
import FullScreen from '_pixiSrc/layout/FullScreen';
import GameConfig from '../libraries/GameConfig';
import GameData from '../ui/GameData';
import GameDistribution from '_ui/GameDistribution';
import I18 from '_pixiSrc/I18';
import Line from './Line';
import { MOBILE } from '_pixiSrc/layout/features';
import MobileUI from '../ui/MobileUI';
import NetworkController from '../network/NetworkController';
import Options from '../ui/Options';
import PayoutsPopup from '../ui/PayoutsPopup';
import Paytable from '../ui/Paytable';
import Sprite from '_pixiSrc/display/Sprite';
import Static from '../libraries/Static';
import TextPanel from '../ui/TextPanel';
import UI from '../ui/UI';
import {
    Utils,
} from '_pixiSrc/Utils';
import Wheel from '../gameEngine/Wheel';

/**
 * @class GameScreen
 * GameScreen class manage game screen and game animation
 */
class GameScreen extends Sprite {
    constructor(w = 320, h = 480) {
        super(null, w, h);

        this.lastWin = 0;

        this.frameDisplayArea = 562;

        this.isSpinAfterAds = false;

        /**
     * @type MobileUI
     */
        this.ui = null;

        AudioManager.playSound('fx', 'intro_long_version', () => {
            if (GameData.getProperty('isFreeGame')) {
                AudioManager.playMusic('free_games_music');
                return;
            }
            AudioManager.playMusic();
            this.showAds(true);
        });

        this.init();
        this.preloadRewardedAd();
    }

    preloadRewardedAd() {
        if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
            gdsdk.preloadAd('rewarded')
                .then((response) => {
                    // A rewarded ad can be shown to user when he/she clicked it.
                    console.log('===preloadRewardedAd===');
                })
                .catch((error) => {
                    // Any Rewarded ad is not available to user.
                    console.error(error);
                });
        }
    }

    showRewardedAds() {
        console.log('show rewarded ads');
        if (gdsdk !== 'undefined' && gdsdk.showAd !== 'undefined') {
            gdsdk.showAd('rewarded')
                .then((response) => {
                    // Reward the player here.
                    setWallet(DEFAULT_USER_DATA.wallet);
                    DynamicData.addValue(GAME_DATA_KEY.COINS, DEFAULT_USER_DATA.wallet);
                    AudioManager.playCoinsSound();
                    APP.glovalErrorView.close();
                })
                .catch((error) => {
                    // An error catched. Please don't give reward here.
                    console.error(error);
                });
        }
    }

    addBalance() {
        setWallet(DEFAULT_USER_DATA.walletWithoutAd);
        DynamicData.addValue(GAME_DATA_KEY.COINS, DEFAULT_USER_DATA.walletWithoutAd);
        AudioManager.playCoinsSound();
        APP.glovalErrorView.close();
    }

    sdkGameStart() {
        // advertisement done, resume game logic and unmute audio
        if (GameData.getProperty('midrollReward') === true) {
            GameData.setProperty('midrollReward', false);
            this.addBalance();
        }

        GameData.setProperty('musicEnabled', GameDistribution.getProperty('musicEnabled'));
        GameData.setProperty('soundEnabled', GameDistribution.getProperty('soundEnabled'));
        if (this.isSpinAfterAds) {
            this.ui.buttons.spin.switchState(0);
            if (GameDistribution.getProperty('isAutospin')) {
                this.ui.buttons.autoButton.clickAction();
                this.startAutospin();
            } else {
                // this.spinButtonClickAction();
            }
        }
        AudioManager.resumeMusic(100);
    }

    sdkGamePause() {
        // pause game logic / mute audio
        console.log('SDK_GAME_PAUSE');
        GameData.setProperty('musicEnabled', false);
        GameData.setProperty('soundEnabled', false);
        AudioManager.stopAllSounds();
        AudioManager.muteMusicOnDisabled();
        if (GameData.getProperty('isAutospin')) {
            this.ui.buttons.autoButton.closeAction();
        }
        this.ui.buttons.spin.switchState(0);
    }

    showAds(skipWinCheck = false) {
        try {
            const win = DynamicData.getValue('lastWin');
            if (skipWinCheck || (!GameDistribution.getProperty('isAdShownRecently') && win >= GameConfig.bigWinsObj.bigWin.minBetMultiplier * DynamicData.getValue('totalBet'))) {
                if (typeof gdsdk !== 'undefined' && gdsdk.showAd !== 'undefined') {
                    GameDistribution.setProperty('isAdShownRecently', true);
                    gdsdk.showAd();
                    GameDistribution.setProperty('musicEnabled', GameData.getProperty('musicEnabled'));
                    GameDistribution.setProperty('soundEnabled', GameData.getProperty('soundEnabled'));
                    GameDistribution.setProperty('isAutospin', GameData.getProperty('isAutospin'));
                    setTimeout(() => {
                        GameDistribution.setProperty('isAdShownRecently', false);
                    }, 60000);
                    return true;
                }
                return false;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
        return false;
    }

    init() {
        APP.resizeDecor();

        this._addWheels();

        if (MOBILE) {
            this._addMobileUI();
        } else {
            this._addUI();
        }

        this._addKeyboardListeners();
        this._getParentMessage();

        this.scale.set(0.99);

        if (GameData.getProperty('isFreeGame')) {
            this.startFreeGames(DynamicData.getValue('FGCounterMax'), DynamicData.getValue(GAME_DATA_KEY.FREEGAMEWIN));
        } else if (DynamicData.getData(GAME_DATA_KEY.SPECIALSPIN).freeSpins > 0) {
            TextPanel.sendMessage('duringSpecialSpin');
            this.ui.disableButtons();
            this.ui.enableButtons();
        }
    }

    showMidrollAd() {
        try {
            if ((!GameDistribution.getProperty('isAdShownRecently'))) {
                GameData.setProperty('midrollReward', true);

                if (typeof gdsdk !== 'undefined' && gdsdk.showAd !== 'undefined') {
                    GameDistribution.setProperty('isAdShownRecently', true);
                    gdsdk.showAd();
                    GameDistribution.setProperty('musicEnabled', GameData.getProperty('musicEnabled'));
                    GameDistribution.setProperty('soundEnabled', GameData.getProperty('soundEnabled'));
                    GameDistribution.setProperty('isAutospin', GameData.getProperty('isAutospin'));
                    setTimeout(() => {
                        GameDistribution.setProperty('isAdShownRecently', false);
                    }, 120000);
                    return true;
                }

                this.addBalance();
                return false;
            }

            this.addBalance();

        } catch (error) {
            console.log(error);
            return false;
        }
    }


    spinButtonClickAction() {
        const params = getUserData();
        if (params.wallet < params.currentBet * 10) {
            this.ui.buttons.spin.switchState(0);
            APP.displayRewardedAd(ERROR.NOT_ENOUGH_BALANCE, {}, false, 'error/ok', () => this.showRewardedAds(), 'error/btn-reload', () => this.showMidrollAd());
            // APP.displayRewardedAd(ERROR.NOT_ENOUGH_BALANCE, {}, false, 'OK', () => this.showRewardedAds());
            // this.showRewardedAds();
            // setWallet(DEFAULT_USER_DATA.wallet);
            // DynamicData.setValue(GAME_DATA_KEY.COINS, DEFAULT_USER_DATA.wallet);
            return;
        }
        if (Wheel.stopExpanding()) {
            this.ui.buttons.spin.switchState(0);
            return;
        }

        GameData.setProperty('isPPAllowed', false);
        GameData.setProperty('isGambleActive', false);
        BigWin.close();
        Paytable.close();
        PayoutsPopup.close();
        Line.hideLines();
        if (!this.ui.isCollected) {
            NetworkController.takeWinAmount();
        }
        this.ui.endGambleGame();

        this.isSpinAfterAds = true;
        if (this.showAds()) {
            return;
        }

        if (APP.glovalErrorView) { return; }

        if (GameData.getProperty('isFreeGame')) {
            if (!this.ui.informPanelFG.visible) {
                this.startFreeGames();
                this.ui.buttons.spin.switchState(0);
                return;
            } else if (DynamicData.getData(GAME_DATA_KEY.FREESPIN).currentFreeSpin === DynamicData.getData(GAME_DATA_KEY.FREESPIN).freeSpins) {
                this.endFreeGames();
                this.ui.buttons.spin.switchState(0);
                return;
            } else if (DynamicData.getData(GAME_DATA_KEY.FREESPIN).currentFreeSpin > 0
                && DynamicData.getData(GAME_DATA_KEY.FREESPIN).freeSpins !== DynamicData.getValue('FGCounterMax')
                && DynamicData.getData(GAME_DATA_KEY.FREESPIN).isFreeSpinAwarded) {
                this.addFreeGames();
                this.ui.buttons.spin.switchState(0);
                return;
            }
        }

        if (MOBILE && GameData.getProperty('isAutospin')) {
            this.clearAutospin();
        }

        this.ui.switchToRegularGame();
        this.startSpin();
        this.ui.isCollected = false;
    }

    /**
   * add mobile ui as current orientation of mobile devices
   * and start listining orientation change event
   */
    _addMobileUI() {
        // this._addOptionsButton(); // add option button to open options menu

        // if full screen is supported by browser then only display fullscreen button
        // if (FullScreen.enabled) {
        //   this._addFullScreenButton();
        // }

        // different ui as per orientation
        if (APP.layout.orientation === 'portrait') {
            this._addPortraitMobileUI();

            // to set frame at top of screen regarding of screen height
            APP.layout.on('fitlayout', this._rearrangeFrameAndBottomPanel, this);
            this._rearrangeFrameAndBottomPanel();
        } else {
            this._addLandScapeMobileUI();
        }

        // handle orientation change for mobile devices
        APP.layout.on('orientationchange', this._handleOrientation, this);
    }

    /**
   * handle orientation on 'orientationchange' event
   */
    _handleOrientation() {
        BigWin.close();
        this.ui.safeRemove(); // remove current UI

        if (APP.layout.orientation === 'landscape') {
            this._addLandScapeMobileUI(); // add landscape ui with current ui button state
            this.wheelsBack.position.set(0, 10); // set frame to fixed position

            // remove listening 'fitlayout' because no need to change frame position
            APP.layout.off('fitlayout', this._rearrangeFrameAndBottomPanel, this);
            return;
        }
        // add portrait ui with current ui button state
        this._addPortraitMobileUI();

        // add listener to 'fitlayout' event because change position of frame as per device height
        APP.layout.on('fitlayout', this._rearrangeFrameAndBottomPanel, this);
    }

    /**
   * set frame to top of the screen
   * @param {*} calculatedSize
   */
    _rearrangeFrameAndBottomPanel(calculatedSize = APP.layout.calculatedSize) {
        this.wheelsBack.position.set(this.x, (0 - calculatedSize.screenHeight + this.frameDisplayArea) / 2);
    }


    /**
   * add portrait UI for mobile device
   */
    _addPortraitMobileUI() {
        // for setting bottom panel position mannually
        const positionConfiguration = {
            bottomPanelPosition: 560,
            gambleParent: this.frame,
        };
        this.ui = this.addChild(new MobileUI(0, 60, positionConfiguration, this.ui));
        this._configureMobileUI();
    }

    /**
   * add landscape UI for mobile device
   */
    _addLandScapeMobileUI() {
        /**
         * for setting spin button position, scale, and its parent
         * by default its { x: 445, y: -313, spinButtonScale: 1.4,
         * spinButtonParent: this, spinButtonZindex: 10 }
         */
        const positionConfiguration = {
            spinButton: { x: 375, y: -20, scale: 0.7 },
            maxbet: { x: 385, y: -115, scale: 0.7 },
            autoButton: { x: 385, y: 75, scale: 0.7 },
            info: { x: 385, y: 180, scale: 0.8 },
            spinButtonParent: this.frame,
            spinButtonZindex: 10,
            gambleParent: this.frame,
        };
        this.ui = this.addChild(new MobileUI(0, 240, positionConfiguration, this.ui));
        this.ui.scale.set(0.91);
        this._configureMobileUI();
    }

    /**
   * used to configure mobile ui.
   * for example, give function to its button to execute on click
   */
    _configureMobileUI() {
        this.ui.resizeUI();
        this.ui.zIndex = 3;
        this.ui.extraButtons = { optionButton: this.ui.buttons.options };

        if (DynamicData.getData(GAME_DATA_KEY.FREESPIN).freeSpins > 0) {
            this.ui.hideBet();
        } else {
            this.ui.showBet();
        }

        const selectRightButton = () => {
            // if left spin button found then remove it
            if (this.ui.spinBackgroundLeft) {
                this.ui.spinBackgroundLeft.safeRemove();
                delete this.ui.spinBackgroundLeft;
                delete this.ui.spinLeftButton;
                this.selectedSpinButtonSide = 'right';// set as right spin button is selected

                this.ui.buttonsGamble.startGambleLeft.safeRemove();
                delete this.ui.buttonsGamble.startGambleLeft;
            }
        };

        this.ui.buttons.spin.clickAction = () => {
            this.ui.selectRightSide();
            this.spinButtonClickAction();
        };
        this.ui.buttons.spin.closeAction = () => {
            if (GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN)) {
                this.ui.buttons.autoButton.switchState(0);
                this.ui.buttons.autoButton.enable();
                this.ui.buttons.autoButton.closeAction();
            } else {
                this.ui.selectRightSide();
                this.stopSpin();
            }
        };

        // if ui has left spin button then add listener for its click events
        if (this.ui.spinLeftButton) {
            const selectLeftButton = () => {
                // if right spin button found then remove it
                if (this.ui.spinBackground) {
                    this.ui.selectedSpinButtonSide = 'left';

                    this.ui.spinBackground.safeRemove();
                    this.ui.spinBackground = null;

                    this.ui.buttonsGamble.startGamble.safeRemove();
                    this.ui.buttonsGamble.startGamble = this.ui.buttonsGamble.startGambleLeft;

                    // use left spin button sprite and object as normal spin button
                    this.ui.buttons.spin = this.ui.spinLeftButton;
                    this.selectedSpinButtonSide = 'left';// set as left spin button is selected
                }
            };

            this.ui.spinLeftButton.clickAction = () => {
                this.ui.selectLeftSide();
                this.spinButtonClickAction();
            };
            this.ui.spinLeftButton.closeAction = () => {
                this.ui.selectLeftSide();
                this.stopSpin();
            };
        }

        this.ui.buttons.autoButton.clickAction = () => {
            if (this.ui.isClicked) {
                this.ui.buttons.autoButton.switchState(0);
                return;
            }
            if (!this.isRolling) {
                this.startAutospin();
            }
            // set isAutospin true
            GameData.setProperty(GAME_PROPERTY_KEY.AUTOSPIN, true);
            this.ui.buttons.autoButton.disable();
        };

        this.ui.buttons.autoButton.closeAction = () => {
            GameData.setProperty(GAME_PROPERTY_KEY.AUTOSPIN, false);

            this.stopAutospin();
            if (!this.isRolling) {
                this.ui.enableButtons();
                //   this.ui.buttons.spin.switchState(0);
                // } else {
                //   this.ui.buttons.spin.disable();
            }
        };

        this.ui.buttons.options.clickAction = () => {
            this.addChild(Options.invoke(0, 0, this.ui));
        };
    }

    /**
   * add option button to open option layout
   */
    _addOptionsButton() {
        this.optionButton = this.frame.addChild(new Button('mobile-ui/options', -375, -235, 1, () => {
            this.addChild(Options.invoke(0, 0, this.ui));
        }, GameConfig.mobileButtonState));

        this.optionButton.zIndex = 2;
    }

    /**
   * add fullscreen button to toggle fullscreen
   */
    _addFullScreenButton() {
        this.fullScreenButton = this.frame.addChild(new Button('buttons/buttons/fullscreen', 380, -235, 0.65, () => {
            FullScreen.toggle();
        }));
        this.fullScreenButton.zIndex = 2;
        this.fullScreenButton.hitArea = new PIXI.Circle(0, 0, 27);
    }


    _addUI() {
        this.ui = this.addChild(new UI(-1, 240));

        this.ui.buttons.spin.clickAction = () => {
            this.spinButtonClickAction();
        };
        this.ui.buttons.spin.closeAction = () => {
            if (GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN)) {
                this.ui.buttons.autoButton.switchState(0);
                this.ui.buttons.autoButton.enable();
                this.ui.buttons.autoButton.closeAction();
            } else {
                this.stopSpin();
            }
        };

        this.ui.buttons.spin.autoClickAction = () => {
            AudioManager.playSound('fx', 'autoplay_1');

            this.startAutospin();
        };
        this.ui.buttons.spin.autoCloseAction = () => {
            AudioManager.playSound('fx', 'autoplay_2');
            this.stopAutospin();
        };

        if (this.ui.buttonsGamble.spin) {
            this.ui.buttonsGamble.spin.clickAction = () => {
                this.spinButtonClickAction();
            };
        }

        this.ui.buttons.autoButton.clickAction = () => {
            if (this.ui.isClicked) {
                this.ui.buttons.autoButton.switchState(0);
                return;
            }
            if (!this.isRolling) {
                this.startAutospin();
            }
            // set isAutospin true
            GameData.setProperty(GAME_PROPERTY_KEY.AUTOSPIN, true);
            this.ui.buttons.autoButton.disable();
        };

        this.ui.buttons.autoButton.closeAction = () => {
            GameData.setProperty(GAME_PROPERTY_KEY.AUTOSPIN, false);
            this.stopAutospin();
            if (!this.isRolling) {
                this.ui.enableButtons();
                // this.ui.buttons.spin.switchState(0);
                // } else {
                //   this.ui.buttons.spin.disable();
            }
        };

        this.ui.buttons.options.clickAction = () => {
            this.addChild(Options.invoke(0, 0, this.ui));
        };
    }

    /**
   * @name _wheelsRotationEnd
   * @description remove last win data and check for new win data
   */
    _wheelsRotationEnd() {
        /**
     * remove last winning data
     */
        DynamicData.setValue('lastWin', 0);
        DynamicData.addValue('lastWin', 0);
        DynamicData.setValue('lastExpandingWin', 0);
        DynamicData.addValue('lastExpandingWin', 0);
        this.isRolling = false;

        if (APP.glovalErrorView && MOBILE) {
            this.ui.buttons.autoButton.switchState(0);
        }

        // if (!MOBILE) {
        //   // if auto spin found then set START_STATE to spin button otherwise set STOP_STATE
        //   if (!GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN)) {
        //     this.ui.buttons.spin.switchState(0);
        //   } else {
        //     this.ui.buttons.spin.switchState(1);
        //   }
        // } else {
        //   /* switch spin button state
        //    * because in mobile, spin and auto spin button are separated
        //    */
        //   this.ui.buttons.spin.switchState(0);
        // }
        this.ui.buttons.spin.switchState(0);

        /**
     * check new winning data
     */
        this._checkWin();
    }

    /**
   * @name stopSpin
   * @description stop spin of reel using stopWheels function
   */
    stopSpin() {
        Wheel.stopWheels(Utils.proxy(this._wheelsRotationEnd, this));
    }

    /**
   * @name startSpin
   * @description start spin
   */
    startSpin() {
        // if (MOBILE) {
        //   /* switch spin button state
        //    * because in mobile, spin and auto spin button are separated
        //    */
        //   this.ui.buttons.spin.switchState(1);
        // }
        this.ui.buttons.spin.switchState(1);

        this.isRolling = true; // the wheels are spinning

        const specialSpin = DynamicData.getData(GAME_DATA_KEY.SPECIALSPIN);
        if (GameData.getProperty('isFreeGame')) {
            TextPanel.sendMessage('duringFG');
        } else if (specialSpin.freeSpins > 0) {
            TextPanel.sendMessage('duringSpecialSpin', specialSpin.currentFreeSpin + 1);
        } else {
            TextPanel.sendMessage('clickSpin');
        }

        AudioManager.stopAllSounds();
        if (!GameData.getProperty('isFreeGame')) { AudioManager.playMusic('reel_spin_slower'); } else { AudioManager.playMusic('free_games_music'); }

        if (GameData.getProperty('isFreeGame')) {
            DynamicData.addValue('FGCounterMax', DynamicData.getData(GAME_DATA_KEY.FREESPIN).freeSpins - DynamicData.getValue('FGCounterMax'));
            DynamicData.addValue('FGCounter', DynamicData.getData(GAME_DATA_KEY.FREESPIN).currentFreeSpin - DynamicData.getValue('FGCounter') + 1);
        }

        Wheel.rotateWheels(Utils.proxy(this._wheelsRotationEnd, this));

        this.ui.disableButtons();
    }

    /**
   * @name startAutospin
   * @description start auto spin
   */
    startAutospin(timeout = 250) {
        this.clearAutospin();
        this.autospinTimer = setTimeout(() => {
            if (GameData.getProperty('isPPOpen') || this.isRolling) {
                this.startAutospin(timeout);
                return;
            }

            this.spinButtonClickAction();
            this.clearAutospin();
        }, timeout);
        GameData.setProperty('isAutospin', true);
    }

    /**
   * @name stopAutospin
   * @description stop auto spin
   */
    stopAutospin() {
        this.clearAutospin();

        GameData.setProperty('isAutospin', false);

        this.ui.enableButtons();

        if (DynamicData.getValue('lastWin') && !GameData.getProperty('isFreeGame') && !this.isRolling && !this.ui.isCollected) {
            this.ui.switchToGambleGame();
        }
    }

    /**
   * @name clearAutospin
   * @description clear auto spin Timer
   */
    clearAutospin() {
        if (this.autospinTimer) {
            clearTimeout(this.autospinTimer);
            this.autospinTimer = null;
        }
    }

    startGiftSpins() {
        if (GameData.getProperty('isGiftSpins')) {
            this.ui.enableButtons();
            return;
        }

        GameData.setProperty('isGiftSpins', true);

        this.ui.openFGWindow('startGS', () => {
            if (GameData.getProperty('isAutospin')) { this.startAutospin(); }
        });
        this.ui.enableButtons();
    }

    endGiftSpins(callback) {
        GameData.setProperty('isGiftSpins', false);

        this.ui.openFGWindow('endGS', () => {
            if (callback) { callback(); }
        });
        this.ui.enableButtons();
    }

    /**
   * @name startFreeGames
   * @param max
   * @param win
   * @description show free spin wining popup and start free spin
   */
    startFreeGames(max = 10, win = 0) {
        if (this.ui.popup) { return; }

        this.ui.informPanelFG.visible = true;
        this.ui.disableButtons();

        Line.hideLines();

        DynamicData.setValue(GAME_DATA_KEY.FREEGAMEWIN, win);
        DynamicData.removeTweens(GAME_DATA_KEY.FREEGAMEWIN);

        DynamicData.setValue('FGCounter', 0);
        DynamicData.setValue('FGCounterMax', max);

        GameData.setProperty('expandingSymbol', NetworkController.getExpandingValue());

        this.ui.openFGWindow('startFG', () => {
            AudioManager.playMusic('free_games_music');
            if (GameData.getProperty('isAutospin')) { this.startAutospin(); }
            this.ui.hideBet();
        });

        if (DynamicData.getData(GAME_DATA_KEY.FREESPIN).isFreeSpinAwarded || DynamicData.getData(GAME_DATA_KEY.FREESPIN).currentFreeSpin === 0) {
            TextPanel.sendMessage('triggerFG');
        } else {
            TextPanel.sendMessage('duringFG');
            this.ui.closeFGWindow();
            this.ui.isExpStopped = true;
            this.ui.shiftExpanding();
            this.ui.hideBet();
        }
        AudioManager.stopCoinsSound();
        AudioManager.playSound('fx', 'fg_start');

        this.ui.enableButtons();
    }

    /**
   * @name addFreeGames
   * @description show free spin wining popup add winning free spin in freespin data
   */
    addFreeGames() {
        AudioManager.playSound('fx', 'fg_retrigger');

        this.ui.openFGWindow('addFG', GameData.getProperty('isAutospin') ? () => this.startAutospin() : null);
        DynamicData.setValue('FGCounterMax', DynamicData.getData(GAME_DATA_KEY.FREESPIN).freeSpins);
        this.ui.enableButtons();
    }

    endFreeGames() {
        this.ui.disableButtons();
        this.ui.informPanelFG.visible = false;

        GameData.setProperty('isFreeGame', false);
        GameData.setProperty('expandingSymbol', false);
        AudioManager.playSound('fx', 'fg_complete');

        this.ui.enableButtons();

        this.lastWin = DynamicData.getValue(GAME_DATA_KEY.FREEGAMEWIN);
        this.ui.switchToRegularGame();

        if (this.lastWin) {
            DynamicData.setValue('lastWin', this.lastWin);
            if (!GameData.getProperty('isAutospin')) {
                this.ui.switchToGambleGame();
                this.stopAutospin();
            }
        }
        TextPanel.sendMessage('FGComplete');

        this.ui.openFGWindow('endFG', (GameData.getProperty('isAutospin'))
            ? () => {
                this.startAutospin();
            }
            : () => {
                // GameData.setProperty('expandingSymbol', false);
                // GameData.setProperty('isFreeGame', false)
            });
        DynamicData.setValue('FGCounter', 0);
        this.ui.showBet();
        this.ui.closeExpanding();
    }

    tick(e) {
        Wheel.tick(e);
    }

    _addWheels() {
        this.wheelsBack = this.addChild(APP.library.getSprite('main/Background'));
        this.wheelsBack.position.set(0, 10);

        this.frame = this.wheelsBack.addChild(APP.library.getSprite('main/frame'));
        this.frame.position.set(0, -10);

        this.topPanel = this.frame.addChild(APP.library.getSprite('main/top-line'));
        this.topPanel.position.set(0, -238);

        // use parent wheel sprite for clipping effect using masking.
        this.wheelSprite = this.frame.addChild(new Sprite());
        const graphicsMask = new PIXI.Graphics();
        graphicsMask.beginFill(0xFFFFFF);
        graphicsMask.drawRect(-374, -178, 746, 355); // size and coordinate of mask on wheel sprite
        graphicsMask.endFill();
        this.wheelSprite.addChild(graphicsMask);
        this.wheelSprite.mask = graphicsMask;

        const positionY = -241;
        this.wheelSprite.addChild(new Wheel(-300, positionY));
        this.wheelSprite.addChild(new Wheel(-151, positionY));
        this.wheelSprite.addChild(new Wheel(-3, positionY));
        this.wheelSprite.addChild(new Wheel(147, positionY));
        this.wheelSprite.addChild(new Wheel(297, positionY));

        Wheel.init(2); // the number of the initial position (taken from the config)

        this.logo = this.frame.addChild(APP.library.getSprite('main/Logo'));
        this.logo.position.set(1, -218);

        this.lincount = this.frame.addChild(APP.library.getSprite('buttons/buttons/line-back'));
        this.lincount.gotoAndStop(0);
        this.lincount.position.set(330, -215);
        this.lincount.count = Static.writeNativeText(this.lincount, 10, 'lato-regular', 0, -10, {
            fill: 0xfcd781,
            size: 16,
            align: ALIGN.CENTER,
            alignText: 'center',
            weight: 'bold',
        });
        this.lincount.text = Static.writeNativeText(this.lincount, I18.f('lines'), 'lato-regular', 0, 7, {
            fill: 0xfcd781,
            size: 12,
            align: ALIGN.CENTER,
            alignText: 'center',
            weight: 'bold',
        });
        Static.setScaleToFitWidthNativeText(this.lincount.text, 38, 0.5, 1);

        this.lines = Line.addLines(this.frame, 0, 0);

        if (FullScreen.enabled) {
            this._addFullScreenButton();
        }
    }

    /**
   * @name _checkWin
   * @description check user winning data
   */
    _checkWin() {
        /**
         * get winning data using checkWin function
         */
        const result = Line.checkWin();
        /**
     * user have free spin or not
     * get expanded win data using getFreeSpinWinResultExpanding function
     */
        let resultExp;
        if (GameData.getProperty(GAME_PROPERTY_KEY.FREEGAME)) {
            resultExp = NetworkController.getFreeSpinWinResultExpanding();
        }

        let sum;
        let expandingSum = 0;
        let expandwin = 0;

        /**
     * user have free spin or not
     * if user have free spin then set win amount and expanding win amount
     * else set win amount
     */
        if (GameData.getProperty(GAME_PROPERTY_KEY.FREEGAME)) {
            if (DynamicData.getData(GAME_DATA_KEY.WIN).expandedWins) {
                expandwin = DynamicData.getData(GAME_DATA_KEY.WIN).expandedWins.expandedWinLines[0].winAmount * DynamicData.getData(GAME_DATA_KEY.WIN).expandedWins.expandedWinLinesCount;
            }
            sum = DynamicData.getData(GAME_DATA_KEY.WIN).winCoins - expandwin;
            expandingSum = expandwin;
            DynamicData.addValue(GAME_DATA_KEY.FREEGAMEWIN, DynamicData.getData(GAME_DATA_KEY.FREESPIN).winAmount - DynamicData.getValue(GAME_DATA_KEY.FREEGAMEWIN));
        } else {
            sum = DynamicData.getData(GAME_DATA_KEY.WIN).winCoins;
        }

        const isFGStarted = !!DynamicData.getData(GAME_DATA_KEY.FREESPIN).isFreeSpinAwarded;

        if (!isFGStarted) {
            GameData.setProperty(GAME_PROPERTY_KEY.PPALLOWED, true);
        }

        /**
     * set current win data as last win
     */
        this.lastWin = sum;
        DynamicData.addValue(GAME_DATA_KEY.LASTWIN, this.lastWin);
        DynamicData.addValue(GAME_DATA_KEY.LASTEXPANDINGWIN, expandingSum);

        if (sum && !GameData.getProperty(GAME_PROPERTY_KEY.FREEGAME) && !isFGStarted && !GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN)) {
            this.ui.switchToGambleGame();
        } else if (isFGStarted) {
            DynamicData.addValue(GAME_DATA_KEY.COINS, sum, null, 1000);
        }

        let callback;
        let giftSpins;

        DynamicData.setValue('GSCounter', giftSpins);

        if (giftSpins) {
            callback = Utils.proxy(this.startGiftSpins, this);
        }

        /**
     * user have free spin or not
     */
        if (GameData.getProperty(GAME_PROPERTY_KEY.FREEGAME)) {
            /**
       * check user wins free spin in free spin
       * if win then add winning free spins and show add free spin popup using addFreeGames function
       * else check current spin is last free spin then ending free using endFreeGames function
       */
            callback = isFGStarted ? Utils.proxy(this.addFreeGames, this)
                : DynamicData.getValue(GAME_DATA_KEY.FREEGAMECOUNTER) >= DynamicData.getValue(GAME_DATA_KEY.FREEGAMECOUNTERMAX) ? Utils.proxy(this.endFreeGames, this) : null;
        } else if (isFGStarted) {
            /**
       * check user wins free spin or not
       * if wins then show popup winning freeSpins popup and start free spin using startFreeGames
       */
            GameData.setProperty(GAME_PROPERTY_KEY.FREEGAME, true);
            callback = Utils.proxy(this.startFreeGames, this);
        }

        if (GameData.getProperty('isGiftSpins') && giftSpins === 0) { // if now the last giftspin, then this is a special case
            callback = Utils.proxy(this.endGiftSpins.bind(this, callback), this);
        }

        this.ui.enableButtons();

        if (!callback) {
            callback = (isWin = false) => {
                if (GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN)) {
                    this.startAutospin();
                    // this.startAutospin(isWin ? 500 : 250);
                } else {
                    this.ui.enableButtons();
                }
            };
        }

        /**
     * show winning line animation using showLines function
     */
        Line.showLines(result, {
            lineAnimationCallback: Wheel.animateSymbols,
            scatterAnimationCallback: isFGStarted ? Wheel.animateScatters : null,
            callback,
            resultExp,
        });
    }

    _addKeyboardListeners() {
        document.documentElement.addEventListener('keydown', (e) => {
            if (e.which !== 32) { return; }

            this.ui.buttons.spin.isMouseDown = true;
            this.ui.buttons.spin.updateState();

            e.preventDefault();
            return false;
        });

        document.documentElement.addEventListener('keyup', (e) => {
            if (e.which !== 32) { return; }

            this.ui.buttons.spin.isMouseDown = false;
            this.ui.buttons.spin.updateState();

            if (this.ui.popup) {
                this.ui.closeFGWindow();
                e.preventDefault();
                return false;
            }
            if (this.ui.expandingWindow) {
                this.ui.onClickHandlerExpanding();
                e.preventDefault();
                return false;
            }

            this.ui.buttons.spin.onClickHandler();

            e.preventDefault();
            return false;
        });
    }

    /**
   * @name _getParentMessage
   * @description get message from parent window
   */
    _getParentMessage() {
        this.on('pointerclick', (e) => {
            this.isAutoSpin = false;
            e.stopPropagation();
        });
        const receiveMessage = (event) => {
            if (event.data && event.data.type !== '') {
                if (event.data.type === 'pauseAutoSpin' && GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN)) {
                    this.isAutoSpin = true;
                    this.ui.buttons.spin.autoCloseAction();
                } else if (event.data.type === 'resumeAutoSpin' && this.isAutoSpin) {
                    this.ui.switchToRegularGame();
                    this.isAutoSpin = false;
                    this.ui.buttons.spin.startAutospin();
                }
            }
        };
        window.addEventListener('message', receiveMessage, false);
    }
}

export default GameScreen;
